import script from "./DetailPaper.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailPaper.vue?vue&type=script&setup=true&lang=js"

import "./DetailPaper.vue?vue&type=style&index=0&id=79689feb&lang=scss"

const __exports__ = script;

export default __exports__